export default __webpack_public_path__ + "static/media/jcb.a7f4b49e.svg";